<!--商品下提示词 砍接团券-->
<template>
	<div>
		<!--<div class="recommend-fine-tip">
			<div class="recommend-tip-color recommend-tip-black">砍</div>
			<div class="recommend-tip-text">砍价最高减
				<span>12.00</span>元
			</div>
			<img v-if="showRight == 1" class="icon-right" src="../assets/images/icon-right.png" alt="">
		</div>
		<div class="recommend-fine-tip">
			<div class="recommend-tip-color recommend-tip-green">接</div>
			<div class="recommend-tip-text">接龙减
				<span>12.00</span>元，最高返<span>12.00</span>元
			</div>
			<img v-if="showRight == 1" class="icon-right" src="../assets/images/icon-right.png" alt="">
		</div>
		<div class="recommend-fine-tip">
			<div class="recommend-tip-color recommend-tip-origin">团</div>
			<div class="recommend-tip-text">拼团
				<span>9.00</span>元起
			</div>
			<img v-if="showRight == 1" class="icon-right" src="../assets/images/icon-right.png" alt="">
		</div>-->
<!--		{{discount}}-->
		<div class="recommend-fine-tip" v-for="(tag, index) in discount">
			<div class="recommend-tip-color recommend-tip-red" :style="'background: '+tag.color">{{tag.tag}}</div>
			<div>{{tag.title}}</div>
			<img v-if="showRight == 1" class="icon-right" src="../assets/images/icon-right.png" alt="">
		</div>
	</div>
</template>
<style scope>
	.recommend-fine-tip {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		/*font-size: 9px;*/
		font-size: 12px;
		padding: 0.05rem 0;
		position: relative;
		margin: 0;
	}
	
	.recommend-tip-color {
		width: 14px;
		height: 14px;
		text-align: center;
		line-height: 14px;
		background: rgba(39, 48, 64, 1);
		border-radius: 0.04rem;
		color: #fff;
		margin-right: 0.05rem;
		overflow: hidden;
	}
	
	.recommend-tip-text {
		color: #666;
	}
	
	.recommend-tip-text span {
		color: #FD2840;
	}
	
	.recommend-tip-green {
		background-color: #42BD56;
	}
	
	.recommend-tip-origin {
		background-color: #FF7500;
	}
	
	.recommend-tip-red {
		background-color: #FF5A5F;
	}
	.icon-right{
		position: absolute;
		right: 0.2rem;
		top: 0.05rem;
		width: 16px;
		height: 16px;
	}
</style>

<script>
export default {
  name: 'TuanItem1',
  props: [
	  'showRight',
		  "discount"
  ],
  data() {
    return {
		
    }
  },
  mounted:function () {
  },
  methods:{
  }
}
</script>



// WEBPACK FOOTER //
// GoodsTips.vue?a1e00bae